import { Input, InputGroup, InputGroupText, Select, DefaultTooltip } from 'twyne-new.ui'

import { useCraftProp } from '../../utils'

function SelectPreview({ icon, mode, label }) {
  const { value } = useCraftProp(`background.${mode}`)

  return <InputGroup>
    <DefaultTooltip content={label}>
      <InputGroupText addonType='prepend'>
        {icon}
      </InputGroupText>
    </DefaultTooltip>
    <Input className='text-left' value={value?.label} readOnly placeholder={label} />
  </InputGroup>
}

function SelectComponent({ options, mode, label }) {
  const { value, setValue } = useCraftProp(`background.${mode}`)

  return <Select
    value={value?.value}
    onChange={newValue => setValue(newValue)}
    options={options}
    placeholder={label}
  />
}

export { SelectComponent, SelectPreview }
